<template>
  <div class="project pt6 pt0-l tc">
      <img style="position: fixed; top: 20px; right: 20px; line-height: 0.85em; z-index: 150;" class="pointer w-20-ns w-40-m w-70" @click="goToProject('close')" src="@/assets/home_button.png">
      <div class="project-details w-100">
        <div class="w-50-ns w-100-m w-100 fr-l fixed-l right-0-ns border-box">
          <div class="project-videos w-100 w-100-m w-80-ns fl-l v-mid-l border-box pl4-l  dt-l">
              <span class="dtc-l v-mid-l">
              <vimeo-player
                class="h-auto"
                v-for="(video, index) in project.data.body[0].items"
                v-show="currentVideo == index"
                v-bind:key="video.video_id"
                ref="player"
                :video-id="video.video_id"
                @ready="onReady"
                :options="{ responsive: true, byline: false, portrait: false, title: false }"
                :player-height="320"
                :player-width="640"></vimeo-player>
                <span class="w-100 dib tr mt2" v-if="project.data.body[0].items.length > 1">
                  <span v-for="(video, index) in project.data.body[0].items"
                        class="f1 b mh2 pointer"
                        :class="{ 'purple-txt-invert': currentVideo == index, 'white': currentVideo != index }"
                        @click="currentVideo = index">{{index + 1}}</span>
                </span>
              </span>
          </div>
          <div class="w-20-ns fr border-box dt project-nav-ns">
            <p class="prev-sign v-mid dtc dib mv0 pointer purple-txt-invert" @click="goToProject('next')">+</p>
          </div>
        </div>
        <div class="project-nav-mobile w-100">
          <p class="prev-sign fl v-mid dtc dib mv0 pointer purple-txt-invert" style="margin-top: -1rem;" @click="goToProject('prev')">-</p>
          <p class="prev-sign fr v-mid dtc dib mv0 pointer purple-txt-invert" style="margin-top: -1rem;" @click="goToProject('next')">+</p>
        </div>
        <div class="w-50-ns w-100-m w-100 fl-l fixed-l border-box">
          <div class="w-20-ns fl border-box dt project-nav-ns">
            <p class="prev-sign v-mid dtc dib mv0 pointer purple-txt-invert" @click="goToProject('prev')">-</p>
          </div>
          <div class="project-info w-100 w-80-l fr-l border-box pr4-l pt6-l pt2">
            <h4 class="desc-title white tl purple-txt-invert ttu mv0">{{project.data.client}} {{project.data.project_title}}</h4>
            <p class="agency-info white mt0 mb4 b f2">{{project.data.role}}</p>
            <!-- <div class="project-description w-50 mv4 tc"> -->
            <h4 class="desc-title white tl purple-txt-invert ttu mv0">The task</h4>
            <p v-for="task_paragraph in project.data.project_task" class="desc white b f2 mt0 mb4">{{task_paragraph.text}}</p>
            <h4 class="desc-title white tl purple-txt-invert ttu mv0">The approach</h4>
            <p v-for="approach_paragraph in project.data.project_approach" class="desc white b f2 mt0 mb4">{{approach_paragraph.text}}</p>
            <!-- </div> -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {_} from 'vue-underscore';

export default {
  name: 'Project',
  components: {
  },
  props: ['project'],
  data() {
    return {
      currentVideo: 0
    }
  },
  methods: {
    onReady() {
      this.playerReady = true;
    },
    play () {
      this.$refs.player.play();
    },
    pause () {
      this.$refs.player.pause();
    },
    goToProject(where) {
      for (var i = 0; i < this.$refs.player.length; i++) {
        this.$refs.player[i].pause();
      }

      if (where == 'next') {
        this.$emit('nextProject');
      }
      else if (where == 'prev') {
        this.$emit('prevProject');
      }
      else {
        // this.$refs.player.pause();
        // for (var i = 0; i < this.$refs.player.length; i++) {
        //   this.$refs.player[i].pause();
        // }

        // const scrollY = document.body.style.top;
        // document.body.style.position = '';
        // document.body.style.top = '';
        // window.scrollTo(0, parseInt(scrollY || '0') * -1);

        document.body.style.overflow = 'auto';

        this.$emit('closeProject');
      }
    }
  },
  created() {

  },
  mounted() {
    var self = this;
  }
}
</script>
<style scoped>
  a, a:visited, a:hover, a:active {color:#000;}

  .close-icon {
    position: fixed;
    left: 20px;
    /*top: 26px;*/
    /*max-width: 52px;*/
    z-index: 125;
    text-align: left;
    text-transform: uppercase;
  }
  .project {
    z-index: 125;
  }

  /*.project div {
    height: auto;
  }*/

  .project-details {
    margin: 0 auto;
  }

  .project-nav {
    height: initial;
    bottom: 0;
    right: 20px;
  }

  .project-nav img {
    max-width: 20px;
  }

  .vimeo {
    /*width: 100%;*/
    /*max-width: 75%;*/
  }

  .project-description {
    /*width: 300px;*/
    margin: 2rem auto;
  }

  .desc-title {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0px;
    /*text-transform: none;*/
    /*margin-top: 0;*/
  }

  .project-info p {
    padding: 0;
    /*font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.5em;*/
    text-align: left;
    /*text-align: center;*/
  }

  .prev-sign {
    font-size: 7em;
    font-weight: bold;
  }

  .flip {
    -moz-transform:    scaleX(-1); /* Gecko */
    -o-transform:      scaleX(-1); /* Opera */
    -webkit-transform: scaleX(-1); /* Webkit */
    transform:         scaleX(-1); /* Standard */

    filter: FlipH;                 /* IE 6/7/8 */
  }

  div {
    height: initial;
    overflow: revert;
  }

  .project-nav-ns {
    display: none;
  }

  .project-nav-mobile {
    display: inline-block;
  }

  /*ns breakpoint*/
  @media screen and (min-width: 30em) {
    div {
      height: 100%;
      overflow: auto;
    }

    .project-nav-ns {
      display: table;
    }

    .project-nav-mobile {
      display: none;
    }

    div.h-auto {
      height: auto !important;
    }

    .prev-sign {
      font-size: 10em;
      font-weight: bold;
    }
  }

  /*medium breakpoint*/
  @media screen and (min-width: 30em) and (max-width: 60em) {
    div {
      height: initial;
      overflow: revert;
    }

    .project-nav-ns {
      display: none;
    }

    .project-nav-mobile {
      display: inline-block;
    }

    .prev-sign {
      font-size: 10em;
      font-weight: bold;
    }
  }
</style>
